import get from "lodash/get";
import React from "react";

const TagsField = ({ source, record = {} }) => (
  <span>{get(record, source) ? get(record, source).join(", ") : ""}</span>
);
export default TagsField;
